import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IPricesFiltersState } from '../../types/developerValuation/pricesFiltersState';
import { IDeveloperValuationState } from '../../types/developerValuation/developerValuationState';

export enum EActionTypes {
  Request = 'realtyValuation/Request',
  Success = 'realtyValuation/Success',
  Failure = 'realtyValuation/Failure',
  SetPriceFilter = 'realtyValuation/SetPriceFilter',
}

type TSuccessActionPayload = Partial<IDeveloperValuationState>;

export const requestAction = actionGenerator<EActionTypes.Request>(EActionTypes.Request);
export const successAction = actionGenerator<EActionTypes.Success, TSuccessActionPayload | null>(EActionTypes.Success);
export const failureAction = actionGenerator<EActionTypes.Failure>(EActionTypes.Failure);

export function setPriceFilterAction<Key extends keyof IPricesFiltersState>(
  payload: ISetPriceFilterPayload<Key>,
): ITypedReduxAction<EActionTypes.SetPriceFilter, ISetPriceFilterPayload<Key>> {
  return {
    type: EActionTypes.SetPriceFilter,
    payload,
  };
}

interface ISetPriceFilterPayload<Key extends keyof IPricesFiltersState> {
  filterName: Key;
  filterValue: IPricesFiltersState[Key];
}

export type TRealtyValuationActions =
  | ReturnType<typeof requestAction>
  | ReturnType<typeof successAction>
  | ReturnType<typeof failureAction>
  | ReturnType<typeof setPriceFilterAction>;
